module.exports = __webpack_public_path__ + "static/wheel-29976b2b83c1dc38767906b4fa49e8b5.mp4";